/** Formato de timestamps en notificaciones (locale fijo por idioma de la app). */

function localeForLang(lang: 'es' | 'en'): string {
  return lang === 'en' ? 'en-US' : 'es-MX';
}

export function formatNotificationDateTime(timestamp: Date, lang: 'es' | 'en' = 'es'): string {
  return timestamp.toLocaleString(localeForLang(lang), {
    dateStyle: 'short',
    timeStyle: 'short',
  });
}

export function formatNotificationTime(timestamp: Date, lang: 'es' | 'en' = 'es'): string {
  return timestamp.toLocaleTimeString(localeForLang(lang), {
    hour: '2-digit',
    minute: '2-digit',
  });
}
